import React, { useState } from 'react';

import { SearchIcon, CalendarIcon } from 'components';
import { Button } from 'reactstrap';

import DatePicker from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';

import 'react-datepicker/dist/react-datepicker.css';
import './date-range.scss'

export function DateRange({ getPeriod }) {
  const [startDate, setStartDate] = useState();
  const [startDateFormatted, setStartDateFormatted] = useState();
  const [endDate, setEndDate] = useState();
  const [endDateFormatted, setEndDateFormatted] = useState();

  const handleStartDate = (date) => {
    const convertedData = convertDateBRFormat(date);
    setStartDateFormatted(convertedData);
    setStartDate(date)
  }

  const handleEndDate = (date) => {
    const convertedData = convertDateBRFormat(date);
    setEndDateFormatted(convertedData);
    setEndDate(date);
  }

  function convertDateBRFormat(unformatteDate) {
    var date = new Date(unformatteDate),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [day, month, date.getFullYear()].join("/");
  }

  const handleFormSubmit = (event) => {
    event.preventDefault();
    getPeriod({
      start: startDateFormatted,
      end: endDateFormatted
    })
  }

  return (
    <form className="d-flex" onSubmit={(event) => handleFormSubmit(event)}>
      <label className="input-group ml-3 d-flex">
        <div className="form-control dashboard-datepicker">
          <DatePicker
            selected={startDate}
            onChange={(date) => handleStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            locale={ptBR}
            placeholderText="Período de:"
            dateFormat="dd/MM/yyyy"
          />
        </div>
        <div className="input-group-append">
          <span className="input-group-text">
            <CalendarIcon className="placeholder-icon" />
          </span>
        </div>
      </label>
      <label className="input-group ml-3 d-flex">
        <div className="form-control dashboard-datepicker">
          <DatePicker
            selected={endDate}
            onChange={(date) => handleEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            locale={ptBR}
            placeholderText="Período até:"
            dateFormat="dd/MM/yyyy"
          />
        </div>
        <div className="input-group-append">
          <span className="input-group-text">
            <CalendarIcon className="placeholder-icon" locale="pt-BR" />
          </span>
        </div>
      </label>
      <Button color={"secundary"}>
        <SearchIcon />
      </Button>
    </form>
  );
};
